module.exports = __webpack_public_path__ + "static/media/michaelSothen.b9503154.png";